import {
  CheckboxSelect,
  DateInput,
  DefaultModalDialog,
  Option,
  Select,
  Text,
} from '~/common/components/defaultUIComponents';
import WorkingInfoApi from '~/common/api/zeiterfassungServerApi/WorkingInfoApi';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { formatName } from '~/common/utils/employeeUtils';
import { Flex, Grid, GridItem } from '@chakra-ui/react';
import { useEmployeesContext } from './state';
import React, { useState } from 'react';
import { useStore } from 'zustand';
import { format } from 'date-fns';

interface DeleteTimeSpanValues {
  from: string;
  to: string;
  employeeIds: string[];
}

type ChooseDeleteTimeSpanEmployee = 'Every' | 'Selected';

export const DeleteTimespanModal: React.FC = () => {
  const [{ data: employees }] = EmployeeApi.hooks.useEmployeeQuery();
  const { mutateAsync: deleteTimespan } =
    WorkingInfoApi.hooks.useDeleteTimespan();
  const employeeStore = useEmployeesContext();
  const { isOpen, onToggle } = useStore(employeeStore, (state) => ({
    isOpen: state.deleteTimespanOpen,
    onToggle: state.toggleDeleteTimespanOpen,
  }));

  const todayInMilliseconds = new Date().valueOf();
  const [chooseDeleteTimeSpanEmployee, setChooseDeleteTimeSpanEmployee] =
    useState<ChooseDeleteTimeSpanEmployee>('Every');

  return (
    <DefaultModalDialog
      dialogHeaderText="employees.deleteTimespan.label"
      submitText="employees.deleteTimespan.submitText"
      isOpen={isOpen}
      onCancel={onToggle}
      onSubmit={(values: DeleteTimeSpanValues) =>
        deleteTimespan({
          from: new Date(values.from),
          to: new Date(values.to),
          request: { employees: values.employeeIds },
        }).then(() => onToggle())
      }
      showCancelButton
      size="2xl"
      initialValues={
        {
          from: format(new Date(), 'yyyy-MM-dd'),
          to: format(new Date(), 'yyyy-MM-dd'),
          employeeIds: [],
        } as DeleteTimeSpanValues
      }
    >
      <Grid templateColumns="repeat(2, 1fr)">
        <GridItem>
          <Text>employees.deleteTimespan.from</Text>
        </GridItem>
        <GridItem>
          <Flex>
            <DateInput
              name="from"
              label=""
              row
              defaultValueMilliseconds={todayInMilliseconds}
              useInFormik
            />
          </Flex>
        </GridItem>
        <GridItem>
          <Text>employees.deleteTimespan.to</Text>
        </GridItem>
        <GridItem mb={2}>
          <DateInput
            name="to"
            label=""
            row
            defaultValueMilliseconds={todayInMilliseconds}
            useInFormik
          />
        </GridItem>
        <GridItem>
          <Text>employees.deleteTimespan.choose.label</Text>
        </GridItem>
        <GridItem>
          <Select
            label=""
            placeholder=""
            onChange={(e) =>
              setChooseDeleteTimeSpanEmployee(
                e.target.value as ChooseDeleteTimeSpanEmployee,
              )
            }
            labelAsText
            row
            ml={2}
            mb={3}
            w="64%"
          >
            <Option value={'Every'}>
              employees.deleteTimespan.choose.every
            </Option>
            <Option value={'Selected'}>
              employees.deleteTimespan.choose.selected
            </Option>
          </Select>
        </GridItem>
        <GridItem colSpan={2}>
          {chooseDeleteTimeSpanEmployee === 'Selected' && (
            <CheckboxSelect
              name="employeeIds"
              orderBy={formatName}
              columns={3}
              fields={employees ?? []}
              labels={formatName}
              values={(e) => e.id}
              keys={(e) => e.id}
            />
          )}
        </GridItem>
      </Grid>
    </DefaultModalDialog>
  );
};
